<script lang="ts">
    import {_} from "svelte-i18n"
    import { Navigation } from "../../utilities/Navigation";

    import TemplateStandard from "../../shared/TemplateStandard.svelte";
    // import ButtonSecondary from "../components/ButtonSecondary.svelte";
    import ZoneList from "./ZoneList.svelte";
    // import {currentMap} from "../../stores/api";
    import ButtonSmallBlack from "../../shared/ButtonSmallBlack.svelte";
    import Separator from "../../shared/Separator.svelte";
    import IconBack from "../../shared/Icons/IconBack.svelte";
    import {getEmptyDefaultRule, TacticalPlanRule} from "../TacticalPlan/TacticalPlanRule";

    export let id: number|'new' = 'new';

</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="main-header">
        <div style="display: flex;">
            <IconBack on:click={()=>{ window.history.back() }} />
            {$_('Zones')}
        </div>
    </div>
    <div slot="main-buttons">
        <ButtonSmallBlack on:click={()=>{
            Navigation.navigate('/map')
        }}
             text={$_('Change map')}
             showIcon={false}
            />
    </div>
    <div slot="content">
        <Separator />
        <ZoneList mapId={id} rule={getEmptyDefaultRule()} />
    </div>
</TemplateStandard>

<style>

</style>